import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { borrower3rdArr } from "./borrowerFormConst";

const Borrower3rdParty = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = (data) => {
    setSubmitLoading(true);
    const id = toast.loading("Form Submission Pending");

    try {
      toast.update(id, {
        render: "Form Submitted Succesfuly",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setSubmitLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Borrower Forms", link: "/borrower/forms" },
            { title: "Borrower 3rd Party Auth." },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">
              BORROWER 3<sup>RD</sup> PARTY AUTHORIZATION FORM
            </h4>
            <form>
              <div className="loans-in-details mt-5">
                {borrower3rdArr?.map((data, index) => {
                  return (
                    <MultipleFormBoxComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  );
                })}
                <button
                  onClick={handleSubmit(onSubmit)}
                  className="btn btn-primary text-white"
                >
                  Submit
                </button>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default Borrower3rdParty;
